import { theme } from "../brand";

/**
 * B2C video look — maps brand tokens to roles in this video. Scenes never
 * hardcode colors; they pick a role here.
 */
export const LOOK = {
  blue: theme.brand.colors.primary[600],
  blueDeep: theme.brand.colors.primary[800],
  blueSoft: theme.brand.colors.primary[300],
  sky: theme.brand.colors.primary[100],
  mist: theme.brand.colors.primary[50],
  white: theme.brand.colors.neutral.white,
  ink: theme.brand.colors.neutral.grey800,
  inkSoft: theme.brand.colors.neutral.grey600,
  muted: theme.brand.colors.neutral.grey400,
  hairline: theme.brand.colors.neutral.grey250,
  /** App page background (behind cards). */
  bg2: theme.semantic.surface.background2,
  /** Drained, colourless background (the "0 €" moment). */
  greyBg: theme.brand.colors.neutral.grey200,
  green: theme.brand.colors.success[600],
  greenSoft: theme.brand.colors.success[100],
  red: theme.brand.colors.error[600],
  orange: theme.brand.colors.warning[600],
  display: theme.fontFamily.interTight,
  body: theme.fontFamily.inter,
  bold: theme.fontWeight.bold,
  semi: theme.fontWeight.semiBold,
  medium: theme.fontWeight.medium,
} as const;

/**
 * Type scale for a 1080×1080 canvas shown ~480–560px wide on the landing
 * (≈0.5×). Anything below `support` gets unreadable on a phone.
 */
export const TYPE = {
  hero: 128,
  headline: 96,
  title: 72,
  support: 48,
  small: 40,
  legal: 28,
} as const;

/** Safe margins (px). The embed has rounded corners (24px CSS ≈ 50px here). */
export const SAFE = 96;

/**
 * The three step scenes share one phone position, so the device stays
 * put across the cuts and only its screen and label change.
 */
export const STEP_PHONE = { width: 420, top: 238 } as const;

/** Consistent deep shadow for phones and floating cards. */
export const FLOAT_SHADOW =
  "0 40px 80px -20px rgba(0, 40, 143, 0.35), 0 12px 24px -8px rgba(0, 0, 0, 0.12)";
